import * as React from 'react';
import { Checkbox, FormField, SpaceBetween } from '@amzn/awsui-components-react-v3';

export interface AccountAssociationCheckboxesProps {
  accountAssociations: Array<{ accountId?: string; iamRole?: string }>;
  selectedRoles: string[];
  onChange: (selectedRoles: string[]) => void;
  errorText?: string;
}

export const AccountAssociationCheckboxes = (props: AccountAssociationCheckboxesProps) => {
  const handleToggle = (role: string, checked: boolean) => {
    const updated = checked ? [...props.selectedRoles, role] : props.selectedRoles.filter((r) => r !== role);
    props.onChange(updated);
  };

  return (
    <FormField
      label='Select IAM role(s)'
      description='Select at least one IAM role for your subscription'
      errorText={props.errorText}
    >
      <SpaceBetween size='xs' direction='vertical'>
        {props.accountAssociations.map((aa) => (
          <Checkbox
            key={aa.iamRole}
            checked={props.selectedRoles.includes(aa.iamRole)}
            onChange={(e) => handleToggle(aa.iamRole, e.detail.checked)}
          >
            {aa.iamRole}
          </Checkbox>
        ))}
      </SpaceBetween>
    </FormField>
  );
};
